export const SET_DELTA = "quillDelta/SET_DELTA";

// Action Creators

/**
 * Set Presences received from server in to redux state
 */
export function setDelta(name, delta) {
  return {
    type: SET_DELTA,
    name,
    delta,
  };
}

export const SET_TEXT = "quillText/SET_TEXT";

// reset quill delta
export const FLUSH_DELTAS = "quillDelta/FLUSH_DELTAS";
export const FLUSH_TEXTS = "quillText/FLUSH_TEXTS";
